"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatedEligibilityCampaignCampaignScheduleToJSON = exports.ValidatedEligibilityCampaignCampaignScheduleFromJSONTyped = exports.ValidatedEligibilityCampaignCampaignScheduleFromJSON = exports.instanceOfValidatedEligibilityCampaignCampaignSchedule = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ValidatedEligibilityCampaignCampaignSchedule interface.
 */
function instanceOfValidatedEligibilityCampaignCampaignSchedule(value) {
    var isInstance = true;
    isInstance = isInstance && "startDate" in value;
    return isInstance;
}
exports.instanceOfValidatedEligibilityCampaignCampaignSchedule = instanceOfValidatedEligibilityCampaignCampaignSchedule;
function ValidatedEligibilityCampaignCampaignScheduleFromJSON(json) {
    return ValidatedEligibilityCampaignCampaignScheduleFromJSONTyped(json, false);
}
exports.ValidatedEligibilityCampaignCampaignScheduleFromJSON = ValidatedEligibilityCampaignCampaignScheduleFromJSON;
function ValidatedEligibilityCampaignCampaignScheduleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'startDate': (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
    };
}
exports.ValidatedEligibilityCampaignCampaignScheduleFromJSONTyped = ValidatedEligibilityCampaignCampaignScheduleFromJSONTyped;
function ValidatedEligibilityCampaignCampaignScheduleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start_date': (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
    };
}
exports.ValidatedEligibilityCampaignCampaignScheduleToJSON = ValidatedEligibilityCampaignCampaignScheduleToJSON;
